import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TCreatePaymentReqData,
  TCreatePaymentResData,
  TConfirmPaymentReqData,
  TConfirmPaymentParams
} from '../types/payment.types';

export const createPaymentService = async (
  data: TCreatePaymentReqData,
  counterpartyGUID: string
): Promise<TCreatePaymentResData> => {
  const url = API_ENDPOINTS.PAYMENTS.COUNTERPARTY_PAYMENTS.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.post<TCreatePaymentResData>(
    url,
    data,
  );
  return res.data;
};

export const confirmPaymentService  = async (
  { data, senderCounterpartyGUID }: TConfirmPaymentParams
): Promise<TConfirmPaymentReqData> => {
  const url = API_ENDPOINTS.PAYMENTS.COUNTERPARTY_PAYMENTS_CONFIRM
    .replace(EApiPathParams.CounterpartyGuid, senderCounterpartyGUID);
  const res = await apiClient.post<TConfirmPaymentReqData>(
    url,
    data,
  );
  return res.data;
};

